import React from 'react';
import { Loader2, LogOut } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const LogoutLoader = ({ isOpen }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/40 backdrop-blur-xl"
        >
          {/* Decorative background gradients */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-rose-200/30 rounded-full blur-[120px] animate-pulse" />
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-100/20 rounded-full blur-[120px] animate-pulse delay-700" />
          </div>

          <motion.div 
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 10 }}
            className="relative flex flex-col items-center gap-6 text-center"
          >
            <div className="relative">
              {/* Main Spinner Ring */}
              <div className="w-20 h-20 rounded-full border-[3px] border-rose-100 border-t-rose-600 animate-spin" />
              
              {/* Inner Pulsing Icon Container */}
              <div className="absolute inset-0 m-auto w-12 h-12 rounded-full bg-rose-50 flex items-center justify-center shadow-inner">
                <LogOut className="text-rose-600 animate-pulse" size={24} />
              </div>

              {/* Orbiting dots for extra "wow" */}
              <div className="absolute inset-0 -m-1 animate-[spin_3s_linear_infinite]">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2 h-2 bg-rose-400 rounded-full blur-[1px]" />
              </div>
            </div>

            <div className="space-y-2">
              <motion.h3 
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="text-2xl font-black text-gray-900 tracking-tight"
              >
                Signing Out
              </motion.h3>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                className="flex items-center gap-2 justify-center"
              >
                <div className="h-px w-4 bg-rose-200" />
                <p className="text-[10px] font-black text-rose-500 uppercase tracking-[0.3em]">
                  Securing Your Session
                </p>
                <div className="h-px w-4 bg-rose-200" />
              </motion.div>
            </div>

            {/* Bottom progress-like indicator */}
            <div className="w-48 h-1 bg-gray-100 rounded-full overflow-hidden mt-2">
              <motion.div 
                className="h-full bg-rose-600"
                initial={{ width: "0%" }}
                animate={{ width: "100%" }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LogoutLoader;

